import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../../../store/store';
import {
  ReqManagerCreateActions,
  EmailValidateActions,
  ClientAdmissionActions,
  ClientStatePasswordGetActions,
  CigoActions,
  TriActions,
  UiActions,
  PioActions,
  GetRequestManagerActions
} from '../../../store/actions';
import { DataNotClientService } from '../../../services/data-not-client.service';
import { LoadingService } from '../../../services/loading.service';
import { SessionService } from '../../../services/session.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  RequestManagerCreate,
  RequestEmailValidate,
  RequestCigo,
  RequestTri
} from 'src/app/shared/interfaces';
import { ApiResponseStatus, CigoResponseLight, CustomerDocumentType, GenericErrorType, StepsNotClientTypes, Utm } from '../../../shared/enums';
import { environment } from 'src/environments/environment';
import { AccountFormatService } from 'src/app/services/account-format.service';
import { FingerPrintHandler } from 'src/app/services/fingerprint.service';
import { v4 as uuidv4 } from 'uuid';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { DatadogService } from 'src/app/services/datadog/datadog.service';
import { TagLogin, TagPage } from 'src/app/store/actions/ui.actions';
import { ResponseCigoData } from 'src/app/shared/interfaces/cigo.interface';
import { Location } from '@angular/common';
import { ContextService } from '../../../services/context.service';
import { Observable, Subscription } from 'rxjs';
import { StaticAssets, StaticAssetsService } from 'src/app/services/static-assets';
import { RequestManagerGet } from 'src/app/shared/interfaces/getRequestManager.interface';
import { CapiService } from 'src/app/services/capi/capi.service';

@Component({
  selector: 'lib-public-landing',
  templateUrl: './public-landing.component.html',
  styleUrls: ['../../../global.scss', './public-landing.component.scss']
})
export class PublicLandingComponent implements OnInit, OnDestroy {
  closeResult = '';
  accountType: string;
  accountTitle: string;
  staticAssetsUrl: string = environment.staticScripts.staticAssets;
  showContent: boolean;
  isJointAccount: boolean;
  showJointAccount: boolean;
  formData: FormGroup;
  mode = environment.mode;
  cigoResponse: CigoResponseLight;
  cigoResponseData;

  redirectionPage = window.location.href;

  suggestion;
  tceaData;
  subs = new Subscription();

  tri$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.tri)
  );
  cigo$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.cigo)
  );
  clientStatePasswordGet$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.clientStatePasswordGet)
  );
  clientAdmission$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.clientAdmission)
  );
  pioSuscription$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.pio)
  );
  emailValidate$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.emailValidateState)
  );
  getRequestManager$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.reqManagerGet)
  );
  createRequestManager$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.reqManagerCreate)
  );

  constructor(
    private store: Store<OnboardingProductsStore.AppState>,
    private dataNotClientService: DataNotClientService,
    private dataDogService: DatadogService,
    public loadingService: LoadingService,
    public contextService: ContextService,
    public sessionService: SessionService,
    public accountFormatService: AccountFormatService,
    private _fb: FormBuilder,
    private modalService: NgbModal,
    private location: Location,
    private staticAssetsService: StaticAssetsService,
    private capiService: CapiService
  ) {
    this.detectDevice();
    this.formData = this._fb.group({
      customerIdentificationNumber: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      customerIdentificationType: [null, Validators.required],
      customerEmail: ['', [Validators.required, Validators.email, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$')]],
      customerPhoneNumber: ['', [Validators.required, Validators.pattern('^9[0-9]*$')]],
      customerJointIdentificationNumber: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      customerJointIdentificationType: [null, Validators.required],
      customerJointPhoneNumber: ['', [Validators.required, Validators.pattern('^9[0-9]*$')]],
      customerJointEmail: ['', [Validators.required, Validators.email, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$')]],
      isCheckTermsPersonalData: [true, Validators.requiredTrue],
      storeBiometricData: [false],
      isCheckTermsCMR: [false]
    });
  }

  getRequestManagerSubs = this.getRequestManager$.subscribe(({ response, error }) => {
    if (!response) {
      return;
    }

    if (error != null) {
      this.actionCleanStateAndRedirect(GetRequestManagerActions);
      return;
    }

    if (response) {
      if (response.client && response.client.operationState.code === ApiResponseStatus.OK) {
        if (environment.mode === 'WEB' && this.cigoResponse === CigoResponseLight.YELLOW || this.cigoResponse === CigoResponseLight.RED) {
          this.dataNotClientService.setGenericErrorType(GenericErrorType.RETAKE_ABR_DERIVATION);
          this.store.dispatch(GetRequestManagerActions.cleanState());
          return this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_SERVICE_ERROR }));
        } else {
          this.dataNotClientService.setIsRetake(true);
          return this.callRedirectToOffer(GetRequestManagerActions);
        }
      } else if (response.client && response.client.operationState.code === ApiResponseStatus.FAIL) {
        this.store.dispatch(GetRequestManagerActions.cleanState());
        this.cigoRedirect(this.cigoResponse, this.cigoResponseData);
      } else {
        this.actionCleanStateAndRedirect(GetRequestManagerActions);
      }
    }
  });

  createRequestManagerSubs = this.createRequestManager$.subscribe(({ response, error }) => {
    if (!response) {
      return;
    }

    if (error != null) {
      this.dataDogService.addCustomError(error, 'Landing Error', environment.mode, { channel: 'not client' });
      this.actionCleanStateAndRedirect(ReqManagerCreateActions);
    }
    if (response) {
      if (response.client && response.client.operationState.code === ApiResponseStatus.OK) {
        this.callRedirectToOffer(ReqManagerCreateActions);
      } else if (response.client && response.client.operationState.code === ApiResponseStatus.FAIL) {
        this.store.dispatch(ReqManagerCreateActions.cleanState());
        this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_NO_OFFER }));
      } else {
        this.actionCleanStateAndRedirect(ReqManagerCreateActions);
      }
    }
  });

  emailValidateSuscription = this.emailValidate$.subscribe(({ response, error }) => {
    if (!response) {
      return;
    }
    // error case
    if (error !== null) {
      this.actionCleanStateAndRedirect(EmailValidateActions);
    }

    if (response) {
      if (response.client && response.joint &&
        response.client.operationState.code === ApiResponseStatus.OK &&
        response.joint.operationState.code === ApiResponseStatus.OK) {
        this.callCreateRequestManager();
      } else if ((response.client && response.client.operationState.code === ApiResponseStatus.FAIL) ||
        (response.joint && response.joint.operationState.code === ApiResponseStatus.FAIL)) {
        this.store.dispatch(EmailValidateActions.cleanState());
        this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_NO_OFFER }));
      } else if (response.client && response.client.operationState.code === ApiResponseStatus.OK ||
        response.client.operationState.code === ApiResponseStatus.DISABLE
      ) {
        this.callCreateRequestManager();
      } else {
        this.actionCleanStateAndRedirect(EmailValidateActions);
      }
    } else {
      this.actionCleanStateAndRedirect(EmailValidateActions);
    }
  });

  clientStatePasswordGet = this.clientStatePasswordGet$.subscribe(({ response, error }) => {
    if (!response) {
      return;
    }
    if (error !== null) {
      return this.actionCleanStateAndRedirect(ClientStatePasswordGetActions);
    }

    // Evaluación si cliente y mancomunado tienen clave creada
    // si servicio falla continuammos el flujo, de lo contrario derivamos a sitio privado
    if (response) {
      this.store.dispatch(ClientStatePasswordGetActions.cleanState());
      if ((response.joint && response.joint.operationState.code === ApiResponseStatus.OK) ||
        (response.client && response.client.operationState.code === ApiResponseStatus.OK)) {
        this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_DERIVATION }));
        // DNI - No cliente no mancomunado.
      } else if (environment.mode === 'WEB' &&
        response.client && response.client.operationState.code === ApiResponseStatus.FAIL) {
        this.callGetRequestManager();
      } else if (environment.mode === 'WEB-PF') {
        if (response.client && response.client.operationState.code === ApiResponseStatus.FAIL &&
          response.joint && response.joint.operationState.code === ApiResponseStatus.FAIL) {
          if (this.checkCanCallPio(true)) {
            this.store.dispatch(CigoActions.cleanState());
            this.store.dispatch(PioActions.getPio());
          } else {
            this.callCae();
          }
        } else if (response.client && response.client.operationState.code === ApiResponseStatus.FAIL) {
          this.callGetRequestManager();
        }
      } else {
        this.actionCleanStateAndRedirect(ClientStatePasswordGetActions);
      }
    } else {
      this.actionCleanStateAndRedirect(ClientStatePasswordGetActions);
    }
  });

  cigo = this.cigo$.subscribe(({ response, error }) => {
    if (!response) {
      return;
    }

    if (error !== null) {
      return this.actionCleanStateAndRedirect(CigoActions);
    }
    if (response) {
      this.cigoResponse = response.client.operationState.code as CigoResponseLight;
      this.cigoResponseData = response.client.data;
      this.store.dispatch(CigoActions.cleanState());
      // Flujo mancomunado - ambos son prospectos
      if (this.isJointAccount) {
        if (response.joint && response.client) {
          if (response.joint.operationState.code === ApiResponseStatus.OK ||
            response.client.operationState.code === ApiResponseStatus.OK) {
            localStorage.setItem('sessionId', response.client.operationState.sessionId);
            this.setCigoResponse(response.client.data, response.joint.data);
            this.checkClientOrNotClient();
          } else {
            if (this.checkCanCallPio(true)) {
              this.store.dispatch(CigoActions.cleanState());
              this.store.dispatch(PioActions.getPio());
            } else {
              // CE - CE - No datos CIGO
              this.callCae();
            }
          }
        }
      } else if (environment.mode === 'WEB' &&
        this.dataNotClientService.getIdentificationType() === CustomerDocumentType.CE &&
        this.cigoResponse !== CigoResponseLight.GREEN) {
        // Derivo en caso de CE - WEB (no dan altas por omni 1)
        return this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_ABR_LIGHT }));
      } else if (this.dataNotClientService.getIsretakeActive()) {
        this.setCigoResponse(this.cigoResponseData);
        if (this.cigoResponseData) {
          this.callClientStatePassword();
        } else {
          this.callGetRequestManager();
        }
      } else if (!this.dataNotClientService.getIsretakeActive()) {
        this.cigoRedirect(this.cigoResponse, this.cigoResponseData);
      } else {
        this.actionCleanStateAndRedirect(CigoActions);
      }
    } else {
      this.actionCleanStateAndRedirect(CigoActions);
    }
  });

  pioSuscription = this.pioSuscription$.subscribe(({ response, error }) => {
    if (!response) {
      return;
    }

    if (error !== null) {
      return this.actionCleanStateAndRedirect(PioActions);
    }
    if (response) {
      this.store.dispatch(PioActions.cleanState());
      if (environment.mode === 'WEB-PF') {
        if (response.client && response.client.operationState.code === ApiResponseStatus.OK &&
          response.joint && response.joint.operationState.code === ApiResponseStatus.OK) {
          this.dataNotClientService.setPioData(response.client.data);
          this.dataNotClientService.setPioDataJoint(response.joint.data);
          this.callCae();
        } else if (response.client && response.client.operationState.code === ApiResponseStatus.OK) {
          this.dataNotClientService.setPioData(response.client.data);
          this.callCae();
        } else if (response.joint && response.joint.operationState.code === ApiResponseStatus.OK) {
          this.dataNotClientService.setPioDataJoint(response.joint.data);
          this.callCae();
        } else if (response.client && response.client.operationState.code === ApiResponseStatus.ERROR ||
          response.joint && response.joint.operationState.code === ApiResponseStatus.ERROR) {
          this.actionCleanStateAndRedirect(PioActions);
        } else {
          this.actionCleanStateAndRedirect(PioActions);
        }
      } else if (environment.mode === 'WEB') {
        if (response.client && response.client.operationState.code === ApiResponseStatus.OK) {
          this.dataNotClientService.setPioData(response.client.data);
          this.callCae();
          // No se encontraron datos en RENIEC.
        } else if (response.client && response.client.operationState.code === ApiResponseStatus.ERROR) {
          this.actionCleanStateAndRedirect(PioActions);
        } else {
          this.actionCleanStateAndRedirect(PioActions);
        }
      } else {
        return this.actionCleanStateAndRedirect(PioActions);
      }
    } else {
      return this.actionCleanStateAndRedirect(PioActions);
    }
  });

  tri = this.tri$.subscribe(({ response, error }) => {
    if (!response) {
      return;
    }
    // error case
    if (error) {
      this.actionCleanStateAndRedirect(TriActions);
    }

    if (response) {
      // Cliente principal y mancomunado.
      if (response.joint && response.client && environment.mode === 'WEB-PF' &&
        response.joint.operationState.code === ApiResponseStatus.OK &&
        response.client.operationState.code === ApiResponseStatus.OK) {
        localStorage.setItem('sessionId', response.client.operationState.sessionId);
        this.capiService.tagCapi('personal-data').subscribe();
        this.callCigo();
        // Cliente principal y mancomunado con fallas en servicio.
      } else if (environment.mode === 'WEB-PF' &&
        (response.joint && response.joint.operationState.code === ApiResponseStatus.FAIL) ||
        (response.client && response.client.operationState.code === ApiResponseStatus.FAIL)) {
        return this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_SERVICE_ERROR }));
        // Cliente principal.
      } else if (response.client && response.client.operationState.code === ApiResponseStatus.OK) {
        if (response.client.operationState.sessionId && !this.contextService.isMobile()) {
          localStorage.setItem('sessionId', response.client.operationState.sessionId);
          this.capiService.tagCapi('personal-data').subscribe();
          this.callCigo();
        }
      } else {
        this.actionCleanStateAndRedirect(TriActions);
      }
    } else {
      this.actionCleanStateAndRedirect(TriActions);
    }
  });

  clientAdmissionSuscription = this.clientAdmission$.subscribe(({ response, error }) => {
    if (!response) {
      return;
    }
    // error case
    if (error !== null) {
      this.actionCleanStateAndRedirect(ClientAdmissionActions);
    }
    // Cliente o mancomunado cliente (Ejecutivo publico)
    if (response && response.joint && response.client && environment.mode === 'WEB-PF' &&
      response.client.operationState.code === ApiResponseStatus.OK &&
      response.joint.operationState.code === ApiResponseStatus.OK) {
      localStorage.setItem('sessionId', response.client.operationState.sessionId);
      this.store.dispatch(ClientAdmissionActions.cleanState());
      // No cliente extranjero
      if (!this.dataNotClientService.getMainIsClient() &&
        this.dataNotClientService.getIdentificationType() !== CustomerDocumentType.DNI) {
        console.log('Pasando por No cliente extranjero WEB-PF');
        return this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_PUBLIC_LANDING_FOREIGN }));
        // No cliente mancomunado extranjero
      } else if (!this.dataNotClientService.getJointIsClient() &&
        this.dataNotClientService.getIdentificationTypeJoint() !== CustomerDocumentType.DNI) {
        console.log('Pasando por No cliente mancomunado extranjero WEB-PF');
        return this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_PUBLIC_LANDING_FOREIGN_JOINT }));
      } else {
        this.callSeon();
      }
      // Flujo Web no mancomunado (WEB)
    } else if (response && response.client &&
      response.client.operationState.code === ApiResponseStatus.OK) {
      this.store.dispatch(ClientAdmissionActions.cleanState());
      // No cliente extranjero
      if (!this.dataNotClientService.getMainIsClient() &&
        this.dataNotClientService.getIdentificationType() !== CustomerDocumentType.DNI) {
        console.log('Pasando por No cliente extranjero WEB');
        this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_PUBLIC_LANDING_FOREIGN }));
      } else {
        this.callCreateRequestManager();
      }
    } else if (response.client.operationState.code !== ApiResponseStatus.OK) {
      this.store.dispatch(ClientAdmissionActions.cleanState());
      this.dataDogService.addCustomEvent('Has not offer', environment.mode, { channel: 'not client' });
      this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_NO_OFFER }));
    }
  });

  detectDevice() {
    this.showContent = this.dataNotClientService.getShowQR();
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || environment.mode !== 'WEB'
    ) {
      this.loadingService.loading = false;
    } else {
      this.subs.add(this.getMobileDerivationData().subscribe((data) => {
        this.suggestion = data;
      }));
    }
  }

  ngOnInit() {
    document.getElementById('white-container').style.display = 'block';
    this.store.dispatch(TagPage({ text: 'personal-data' }));
    this.accountType = this.accountFormatService.getName();
    this.accountFormatService.getAccountNameFromAssets().subscribe((accountTitle) => {
      this.accountTitle = accountTitle;
    });
    this.dataNotClientService.setAccountType(this.accountType);
    this.allowJointAccount();
    this.formData.controls['customerJointIdentificationNumber'].disable();
    this.formData.controls['customerJointIdentificationType'].disable();
    this.formData.controls['customerJointEmail'].disable();
    this.formData.controls['customerJointPhoneNumber'].disable();
    this.store.select('stepsNoClient').subscribe();
    if (!this.contextService.isMobile()) {
      console.log('public landing contextService is not mobile sessionId');
      // Se setea session id en 1 para que el flujo no se rompa al agregar un header en null
      localStorage.setItem('sessionId', '1');
    }
    this.store.dispatch(ClientAdmissionActions.cleanState());
    this.store.dispatch(TriActions.cleanState());
    this.store.dispatch(PioActions.cleanState());
    this.store.dispatch(CigoActions.cleanState());
    this.store.dispatch(ClientStatePasswordGetActions.cleanState());
    this.store.dispatch(EmailValidateActions.cleanState());
    this.store.dispatch(ReqManagerCreateActions.cleanState());
    this.store.dispatch(GetRequestManagerActions.cleanState());

    this.subs.add(this.getTCEAData().subscribe((data) => {
      this.tceaData = data;
    }));

    setTimeout(() => {
      this.loadingService.loading = false;
    }, 200);
    // DATA FOR ANALYTICS
    this.dataDogService.addPageView(StepsNotClientTypes.STEP_PUBLIC_LANDING);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
    this.cigo.unsubscribe();
    this.getRequestManagerSubs.unsubscribe();
    this.createRequestManagerSubs.unsubscribe();
    this.emailValidateSuscription.unsubscribe();
    this.clientAdmissionSuscription.unsubscribe();
    this.tri.unsubscribe();
  }

  continue() {
    if (this.isJointAccount) {
      if (this.formData.controls['customerJointIdentificationNumber'].invalid ||
        this.formData.controls['customerJointIdentificationType'].invalid ||
        this.formData.controls['customerJointEmail'].invalid ||
        this.formData.controls['customerJointPhoneNumber'].invalid) {
        return;
      }
    }
    if (this.formData.dirty === false || this.formData.invalid) {
      return;
    }
    // Data for session
    this.sessionService.setItem('customerIdentificationType', this.formData.controls['customerIdentificationType'].value === 'DNI' ? '1' : '4');
    this.sessionService.setItem('customerIdentificationNumber', this.formData.controls['customerIdentificationNumber'].value);
    // Seteo de datos para utilizar en el flujo.
    this.setClientData();
    this.dataNotClientService.setIsJointAccount(this.isJointAccount);

    // Data dog set context user
    this.dataDogService.addContextUser(this.dataNotClientService.getIndentificationNumber());

    const fingerPrintHandler = new FingerPrintHandler();
    fingerPrintHandler.getFingerprint().subscribe((fingerprint) => {
      const device = JSON.parse(window.atob(fingerprint));
      this.callTri(device, fingerprint);
    });
    this.loadingService.loading = true;
  }

  // Metodo para limpiar el estado luego de un error de servicio.
  actionCleanStateAndRedirect(action) {
    this.store.dispatch(action.cleanState());
    this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_SERVICE_ERROR }));
    return;
  }

  setCigoResponse(data: ResponseCigoData, dataJoint?: ResponseCigoData) {
    // Cliente - Con datos en cigo.
    if (data) {
      this.dataNotClientService.setMainIsClient(true);
      this.dataNotClientService.setCigoData(data);
      this.dataNotClientService.setIsProspect(true);
      console.log('Soy cliente');
    } else {
      // No cliente
      this.dataNotClientService.setMainIsClient(false);
      this.dataNotClientService.setIsProspect(false);
    }
    // Cliente mancomunado - Con datos en cigo.
    if (dataJoint) {
      this.dataNotClientService.setCigoDataJoint(dataJoint);
      this.dataNotClientService.setJointIsClient(true);
      console.log('Soy cliente mancomunado');
    } else {
      // No cliente mancomunado
      this.dataNotClientService.setJointIsClient(false);
    }
  }

  checkClientOrNotClient() {
    // Se Verifica si ambos son clientes.
    if (this.dataNotClientService.getMainIsClient() && this.dataNotClientService.getJointIsClient()) {
      this.store.dispatch(CigoActions.cleanState());
      return this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_DERIVATION }));
    } else {
      return this.callClientStatePassword();
    }
  }

  setClientData() {
    this.dataNotClientService.setIndentificationNumber(this.formData.controls['customerIdentificationNumber'].value);
    this.dataNotClientService.setIdentificationType(this.formData.controls['customerIdentificationType'].value === 'DNI' ? '1' : '4');
    this.dataNotClientService.setEmail(this.formData.controls['customerEmail'].value);
    this.dataNotClientService.setPhoneNumber(this.formData.controls['customerPhoneNumber'].value);
    this.dataNotClientService.setClientIsForeign(this.formData.controls['customerIdentificationType'].value === 'DNI' ? false : true);
    if (this.isJointAccount) {
      this.dataNotClientService.setIndentificationNumberJoint(this.formData.controls['customerJointIdentificationNumber'].value.toString());
      this.dataNotClientService.setIdentificationTypeJoint(this.formData.controls['customerJointIdentificationType'].value === 'DNI' ? '1' : '4');
      this.dataNotClientService.setEmailJoint(this.formData.controls['customerJointEmail'].value);
      this.dataNotClientService.setPhoneNumberJoint(this.formData.controls['customerJointPhoneNumber'].value);
      this.dataNotClientService.setJointIsForeign(this.formData.controls['customerJointIdentificationType'].value === 'DNI' ? false : true);
    }
    const params = {
      isJointAccount: this.isJointAccount,
      document: this.formData.controls['customerIdentificationNumber'].value,
      country: 'PE',
      documentType: this.formData.controls['customerIdentificationType'].value
    };

    this.store.dispatch(TagLogin({ params }));
  }

  enableJointAccount() {
    this.isJointAccount = !this.isJointAccount;
    if (this.isJointAccount) {
      this.formData.controls['customerJointIdentificationNumber'].enable();
      this.formData.controls['customerJointIdentificationType'].enable();
      this.formData.controls['customerJointEmail'].enable();
      this.formData.controls['customerJointPhoneNumber'].enable();
    } else {
      this.formData.controls['customerJointIdentificationNumber'].disable();
      this.formData.controls['customerJointIdentificationType'].disable();
      this.formData.controls['customerJointEmail'].disable();
      this.formData.controls['customerJointPhoneNumber'].disable();
    }
  }

  allowJointAccount() {
    if (environment.mode === 'WEB-PF' && this.accountType !== 'CTS') {
      this.showJointAccount = true;
    }
  }

  callTri(device, fingerprint) {
    const identifier = uuidv4();
    this.dataNotClientService.setTriSessionID(identifier);
    const request: RequestTri = {
      device,
      fingerprint,
      identifier,
      client: environment.mode === 'WEB' ? {
        customerIdentificationType: this.dataNotClientService.getIdentificationType(),
        customerIdentificationNumber: this.dataNotClientService.getIndentificationNumber(),
        isForeign: this.dataNotClientService.clientIsForeign(),
        storeBiometricData: this.formData.controls.storeBiometricData.value,
        loyaltyAuthorization: this.formData.controls.isCheckTermsCMR.value,
        privacyAuthorization: this.formData.controls.isCheckTermsPersonalData.value
      } : {
        customerIdentificationType: this.dataNotClientService.getIdentificationType(),
        customerIdentificationNumber: this.dataNotClientService.getIndentificationNumber(),
        isForeign: this.dataNotClientService.clientIsForeign()
      }
    };
    if (this.isJointAccount) {
      request.joint = {
        customerIdentificationNumber: this.dataNotClientService.getIndentificationNumberJoint(),
        customerIdentificationType: this.dataNotClientService.getIdentificationTypeJoint(),
        isForeign: this.dataNotClientService.jointIsForeign()
      };
    }
    if (Object.keys(this.setUtmParams()).length > 0) {
      request.utm = this.setUtmParams();
    }

    this.store.dispatch(TriActions.getTri({ request }));
  }

  callCigo() {
    const request: RequestCigo = {
      client: {
        cellphone: this.dataNotClientService.getPhoneNumber(),
        email: this.dataNotClientService.getEmail()
      }
    };

    if (this.isJointAccount) {
      request.joint = {
        cellphone: this.dataNotClientService.getPhoneNumberJoint(),
        email: this.dataNotClientService.getEmailJoint()
      };
    }
    // TRI es el llamado previo
    this.store.dispatch(TriActions.cleanState());
    return this.store.dispatch(CigoActions.getCigo({ request }));
  }

  // Metodo que evalua para donde debemos redireccionar al usuario post CIGO o GetRequestManager
  cigoRedirect(reponseLight: CigoResponseLight, cigoData) {
    // IMPORTANTE: Ahora se evalua el color del semaforo - responseLight
    // Y se debe setear si es o no cliente con setCigoResponse
    this.setCigoResponse(cigoData);
    if (reponseLight === CigoResponseLight.RED) {
      console.log('Abr Light');
      return this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_ABR_LIGHT }));
    }

    if ((reponseLight === CigoResponseLight.GREEN || reponseLight === CigoResponseLight.YELLOW)) {
      if (this.dataNotClientService.getMainIsClient()) {
        console.log(`Semaforo ${reponseLight} y voy por client state password`);
        return this.callCae();
      } else if (this.dataNotClientService.clientIsForeign()) {
        console.log(`Semaforo ${reponseLight} y voy por CAE`);
        return this.callCae();
      } else if (!this.dataNotClientService.clientIsForeign()) {
        console.log(`Semaforo ${reponseLight} y voy por PIO`);
        return this.store.dispatch(PioActions.getPio());
      } else {
        console.log('Respuesta no esperada');
        this.actionCleanStateAndRedirect(CigoActions);
      }
    }
    // RESPUESTA NO ESPERADA
    this.actionCleanStateAndRedirect(CigoActions);
  }

  // "emailage"
  callSeon() {
    let request: RequestEmailValidate = {};
    this.store.dispatch(ClientAdmissionActions.cleanState());
    this.store.dispatch(EmailValidateActions.getEmailValidate({ request }));
  }

  callCae() {
    this.store.dispatch(ClientStatePasswordGetActions.cleanState());
    this.store.dispatch(ClientAdmissionActions.getClientAdmission({ request: {} }));
  }

  callGetRequestManager() {
    const request: RequestManagerGet = {};
    return this.store.dispatch(GetRequestManagerActions.getReqManagerGet({ request }));
  }

  callCreateRequestManager() {
    const request: RequestManagerCreate = {};
    this.store.dispatch(ReqManagerCreateActions.getReqManagerCreate({ request }));
  }

  callClientStatePassword() {
    this.store.dispatch(CigoActions.cleanState());
    this.store.dispatch(ClientStatePasswordGetActions.getClientStatePasswordGet());
  }

  callRedirectToOffer(action) {
    this.dataDogService.addCustomEvent('Landing Complete', environment.mode, { channel: 'not client' });
    this.store.dispatch(action.cleanState());
    this.dataDogService.addCustomEvent('Has offer', environment.mode, { channel: 'not client' });
    this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_OFFER }));
  }

  checkCanCallPio(isJoint: boolean): boolean {
    let canCall: boolean;
    if (isJoint) {
      canCall = (!this.dataNotClientService.getMainIsClient() &&
        this.dataNotClientService.getIdentificationType() === CustomerDocumentType.DNI) ||
        (!this.dataNotClientService.getJointIsClient() &&
          this.dataNotClientService.getIdentificationTypeJoint() === CustomerDocumentType.DNI);
    } else {
      canCall = !this.dataNotClientService.getMainIsClient() &&
        this.dataNotClientService.getIdentificationType() === CustomerDocumentType.DNI;
    }
    return canCall;
  }

  openPersonalModal(content) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'onboarding-personal-data-modal', size: 'lg' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  openCMRModal(content) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'onboarding-cmr-data-modal', size: 'lg' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  setUtmParams(): Utm {
    const url = this.location.normalize(this.location.path());
    const utm: Utm = {};
    url.split(/[?/&]+/).forEach((p) => {
      const [key, value] = p.split('=');
      if (key.startsWith('utm')) {
        utm[key] = value;
      }
    });
    return utm;
  }

  checkPrivacy() {
    const link = `${environment.staticScripts.staticAssets}pdf/privacyPolitics.pdf`;
    window.open(link, '_blank');
  }

  checkTerms() {
    const link = `${environment.staticScripts.staticAssets}pdf/cmrTermsAndConditions.pdf`;
    window.open(link, '_blank');
  }

  getMobileDerivationData(): Observable<any> {
    return this.staticAssetsService.getStaticResources<any>(
      StaticAssets.mobileDerivation
    );
  }

  getTCEAData(): Observable<any> {
    return this.staticAssetsService.getStaticResources<any>(
      StaticAssets.TCEA
    );
  }

  getStaticPDF() {
    const link = `${environment.staticScripts.staticAssets}pdf/biometricData.pdf`;
    window.open(link, '_blank');
  }
}
